import { render, staticRenderFns } from "./ServicesTab.vue?vue&type=template&id=e1b83ef4"
import script from "./ServicesTab.vue?vue&type=script&lang=js"
export * from "./ServicesTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports